// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6f14bfff","239":"9b0842b3","455":"c05078e7","594":"476ffc24","885":"a02990d1"}[chunkId] + ".chunk.js";
};